import { render } from "./FileUploadModal.vue?vue&type=template&id=1168c5a2"
import script from "./FileUploadModal.vue?vue&type=script&lang=js"
export * from "./FileUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__